import { createHelpers } from 'vuex-map-fields';

const { getOrdersShipStateField, updateOrdersShipStateField } = createHelpers({
    getterType: `getOrdersShipStateField`,
    mutationType: `updateOrdersShipStateField`,
});


const state = {

    pagination : {
        limit : 50,
        limitstart : 0,
        pagesCurrent : 1,
        pagesStart : 1,
        pagesStop : 0,
        pagesTotal :1,
        total : 0
    },
    list: [],
    doc_type: 0,
    filter: [],

    all_filter : [],

    send_list : {
        limit_start : 0,
        direction : "DESC",
        ordering  : "o.added"
    }

};


const getters = {
    getListState(state) {
        return state.list;
    },

    getFilterState(state) {
        return state.filter;
    },

    getOrdersShipStateField,

};
// actions
const actions = {

    LOAD_PAGINATION({commit},data) {
        state.pagination = {...state.pagination,...data};
    },

    LOAD_STATES({commit},data) {
        state.list = {...state.list,...data.list};
        state.filter = {...state.filter,...data.filter};
        state.all_filter = {...state.all_filter,...data.all_filter};
        EventBus.$emit('shiporders_reload', state);
    },


    LOAD_STATE({commit}) {
        /* axios.get('index.php?option=com_imc_docs&task=api.getUser').then(({data}) => {
             if(data.status === "operation_success") {
                 state.user = {...state.user,...data.message};
                 EventBus.$emit('user_added', state.user);
             }
         })*/
    },

};


// mutations
const mutations = {
    updateOrdersShipStateField,

};


export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
}
